import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ShippingInsuredValueInput')
export class ShippingInsuredValue {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('siv') })
  _id: string

  @Field(() => Float)
  @Prop({ type: Number })
  amount: number

  @Field(() => String)
  @Prop({ type: String })
  currency: string
}
